import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import * as fromRoot from '../../../../../../../../state/app.state';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { CreateFolderRequest } from '../../../../../../core/projects.actions';
import { projectDocumentsBreadcrumbs, projectDocumentsCurrentRootId } from '../../../../../../core/projects.selectors';
import { AnalyticsService } from '../../../../../../../../shared/services/analytics.service';

@Component({
    selector: 'app-create-new-folder',
    templateUrl: './create-new-folder.component.html',
    styleUrls: ['./create-new-folder.component.scss'],
    standalone: false
})
export class CreateNewFolderComponent implements OnInit, OnDestroy {
  heading = '';
  action: any;
  projectId: any;
  breadcrumbs: Array<{ id: string; name: string }> = [];
  currentRootId: string | null = null;

  form = new FormGroup<any>({
    name: new FormControl({ value: null, disabled: false }),
  });
  formFields: any[] = [];

  private readonly onDestroy = new Subject<void>();

  constructor(
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<CreateNewFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private analyticsService: AnalyticsService,
  ) {
    if (data) {
      this.projectId = data?.projectId;
    }
  }

  ngOnInit() {
    // Subscribe to breadcrumbs and currentRootId from store
    this.store
      .select(projectDocumentsBreadcrumbs)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(breadcrumbs => {
        this.breadcrumbs = breadcrumbs || [];
      });

    this.store
      .select(projectDocumentsCurrentRootId)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(currentRootId => {
        this.currentRootId = currentRootId;
      });
  }

  close(): void {
    this.clear();
    this.dialogRef.close();
  }

  clear(): void {
    this.form.reset();
  }

  create(): void {
    const { name } = this.form.getRawValue();

    if (!name) {
      return;
    }

    // Build path based on breadcrumbs
    // If we're in a folder (have breadcrumbs), build the full path
    // Otherwise, just use the folder name
    let path = '';

    if (this.breadcrumbs.length > 0) {
      // Build path from breadcrumbs: /folder1/folder2/folder3/newFolderName
      const breadcrumbPath = this.breadcrumbs.map(b => b.name).join('/');
      path = `/${breadcrumbPath}/${name}`;
    } else {
      // Root level folder
      path = `/${name}`;
    }

    const payload = {
      projectId: this.projectId,
      path,
    };

    this.store.dispatch(CreateFolderRequest({ payload }));

    this.analyticsService.capture('document_folder_created', {
      project_id: this.projectId,
    });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
